<template>
  <div class="AboutTrackMan">
    <div class="homepage">
      <!-- <h2 class="Whitetitle">{{acf.acf.trackman_title}}</h2>
      <p class="WhiteStandard-text aboutTrack-width" v-html="acf.acf.trackman_blog"></p> -->
      <b-row class="container optionAbout">
        <b-col class="above1200" lg="4" v-for="(option, index) in acf" :key="index">
            <div class="borderWhite">
                <div class="aboutBlocks">
                    <div class="ImageLogoSection">
                        <img :src="option.image" class="ImageLogo" :class="option.class">
                    </div>
                    <h2 class="Whitetitle">{{option.title}}</h2>
                    <p class="aboutBlock-Text" v-html="option.description">
                    </p>
                    <div class="buttonArea">
                        <template >
                            <a data-v-6ee518b5="" :href="option.button_link" class="" target="_blank">
                                <button data-v-6ee518b5="" type="button" class="btn HomepageBtn btn-secondary" :class="option.button_class">{{option.button_text}}</button>
                            </a>
                        </template>
                    </div>
                    <div :class="option.button_class" class="triangle-right"></div>
                </div>
            </div>
        </b-col>
        <b-col class="below1200" lg="6" v-for="(option, index) in acf" :key="index">
            <div class="borderWhite">
                <div class="aboutBlocks">
                    <div class="ImageLogoSection">
                        <img :src="option.image" class="ImageLogo" :class="option.class">
                    </div>
                    <h2 class="Whitetitle">{{option.title}}</h2>
                    <p class="aboutBlock-Text" v-html="option.description">
                    </p>
                    <div class="buttonArea">
                        <a data-v-6ee518b5="" :href="option.button_link" class="" target="_self">
                            <button data-v-6ee518b5="" type="button" class="btn HomepageBtn btn-secondary" :class="option.button_class">{{option.button_text}}</button>
                        </a>
                    </div>
                    <div :class="option.button_class" class="triangle-right"></div>
                </div>
            </div>
        </b-col>
        <!-- <b-col lg="3">
            <div class="borderWhite">
                <div class="aboutBlocks">
                    <div class="ImageLogoSection">
                        <img src="https://wp-ocssport.ocs-sport.com/golfpark/wp-content/uploads/sites/4/2024/06/Golf-Sim.png" class="ImageLogo">
                    </div>
                    <h2 class="Whitetitle">Golf Practise</h2>
                    <p class="aboutBlock-Text">
                        Practise your swing and improve your game in the top of the range Golf simulator.
                    </p>
                    <div class="triangle-right"></div>
                </div>
            </div>
        </b-col>
        <b-col lg="3">
            <div class="borderWhite">
                <div class="aboutBlocks">
                    <div class="ImageLogoSection">
                        <img src="https://wp-ocssport.ocs-sport.com/golfpark/wp-content/uploads/sites/4/2024/06/Group-64.png" class="ImageLogo">
                    </div>
                    <h2 class="Whitetitle">Putting Green</h2>
                    <p class="aboutBlock-Text">
                        Hone your skills on our outside 9 hole putting green.
                    </p>
                    <div class="triangle-right"></div>
                </div>
            </div>
        </b-col>
        <b-col lg="3">
            <div class="borderWhite">
                <div class="aboutBlocks">
                    <div class="ImageLogoSection">
                        <img src="https://wp-ocssport.ocs-sport.com/golfpark/wp-content/uploads/sites/4/2024/06/Group-49.png" class="ImageLogo coachingLogo">
                    </div>
                    <h2 class="Whitetitle">Golf Coaching</h2>
                    <p class="aboutBlock-Text">
                        We’ve partnered with top coaches to offer lessons and instruction, including swing evaluation and beginner lessons.
                    </p>
                    <div class="triangle-right"></div>
                </div>
            </div>
        </b-col>
        <b-col lg="3">
            <div class="borderWhite">
                <div class="aboutBlocks">
                    <div class="ImageLogoSection">
                        <img src="https://wp-ocssport.ocs-sport.com/golfpark/wp-content/uploads/sites/4/2024/06/Path-83.png" class="ImageLogo exclusive-Club">
                    </div>
                    <h2 class="Whitetitle">Exclusive Club</h2>
                    <p class="aboutBlock-Text">
                        Golfpark is an exclusive club allowing members private bookings.
                    </p>
                    <div class="triangle-right"></div>
                </div>
            </div>
        </b-col> -->
      </b-row>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'SimPark Options',
  components: {

  },
  data: function() {
    return {
      acf: [],
    };
  },
  methods: {
    isMobile() {
        if( screen.width <= 500 ) {
            return true;
        }
        else {
            return false;
        }
    },
  },
  mounted() {
    axios //add API Call
        .get(
            process.env.VUE_APP_API_URL + 'simpark' + "/wp-json/wp/v2/pages/4" + '?randomadd=' +
          new Date().getTime()
        ) // Page number changed on each page based on JSON page id you are calling
        .then((response) => (
            this.acf = response.data.acf.options
        )); //API data wanted pulled out
  },
}
</script>

<style scoped>
button.HomepageBtn:hover {
    background-color: #707070;
    border-color: #707070 !important;
    color: #fff;
}
button.HomepageBtn{
    background-color: #FF8B17;
    border-color: #FF8B17 !important;
    border-radius: 50px;
    width: 163px;
    height: 31px;
    line-height: 1;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    width: 252px;
    height: 54px;
    margin-top: 65px;
    font-family: "noto-sans", sans-serif;
}
img.ImageLogo.motor {
    width: 120px;
    height: auto;
    margin-top: 41px;
}
.triangle-right.flightbtn {
    border-left: 61px solid #5d8ef0;
}
.triangle-right.motorbtn {
    border-left: 61px solid #dd102c;
}
.buttonArea {
    position: absolute;
    bottom: 70px;
    left: 0;
    right: 0;
}
button.btn.HomepageBtn.btn-secondary.flightbtn {
    background-color: #5d8ef0;
    border-color: #5d8ef0 !important;
}
button.btn.HomepageBtn.btn-secondary.motorbtn{
    background-color: #D80E1F;
    border-color: #D80E1F !important;
}
button.btn.HomepageBtn.btn-secondary.noPointer.flightbtn {
    cursor: default;
}
button.btn.HomepageBtn.btn-secondary.noPointer.motorbtn {
    cursor: default;
}
.optionAbout {
    margin: auto;
    /* margin-right: 85px */
}
.Whitetitle {
    color: #fff;
    font-size: 40px;
    font-family: "korolev", sans-serif;
    font-weight: 700;
    font-style: italic;
}
.AboutTrackMan {
    background-color: #1A1A1A;
    padding: 50px;
    padding-top: 90px;
    padding-bottom: 90px;
}
.WhiteStandard-text {
    font-size: 24px;
    color: #fff;
    font-family: "noto-sans", sans-serif;
    font-weight: 400;
    font-style: normal;
}
.aboutTrack-width {
    width: 70%;
    text-align: center;
    margin: auto;
    padding-top: 30px;
    padding-bottom: 70px;
}
.borderWhite {
    border: 1px solid #FFFFFF;
}
.ImageLogo {
    height: 70px;
    width: 70px;
}
.coachingLogo {
    width: 50px;
}
.exclusive-Club {
    height: 50px;
    position: relative;
    top: 20px;
    margin-bottom: 20px;
}
.aboutBlocks {
    padding: 30px;
    height: 610px;
}
p.aboutBlock-Text {
    color: #fff;
    font-size: 20px;
    padding-top: 30px;
    font-family: "noto-sans", sans-serif;
    font-weight: 400;
    font-style: normal;
}
.triangle-right {
    width: 0;
    height: 0;
    border-top: 60px solid transparent;
    border-left: 61px solid #FF8B17;
    border-bottom: 0px solid transparent;
    transform: rotate(270deg);
    position: absolute;
    right: 16px;
    bottom: 2.1px;
}
.ImageLogoSection {
    padding-top: 40px;
    padding-bottom: 50px;
}
@media only screen and (max-width: 1366px) {
    .aboutBlocks {
        padding: 30px;
        height: 700px;
    }
}
@media only screen and (min-width: 1201px) {
    .below1200 {
        display: none;
    }
}
@media only screen and (max-width: 1200px) {
    .Whitetitle {
        color: #fff;
        font-size: 35px;
        font-family: "korolev", sans-serif;
        font-weight: 700;
        font-style: italic;
    }
    .above1200 {
        display: none;
    }
    .aboutBlocks {
        padding: 30px;
        height: 535px;
    }
    .below1200.col-lg-6 {
        margin-bottom: 30px;
    }
}
@media only screen and (max-width: 768px) {
    .buttonArea {
        position: absolute;
        bottom: 90px;
        left: 0;
        right: 0;
    }
    p.aboutBlock {
        font-size: 18px;
    }
    .triangle-right {
        bottom: 27.1px;
        border-top: 40px solid transparent;
        border-left: 40px solid #FF8B17;
    }
    .triangle-right.flightbtn {
        border-left: 40px solid #5d8ef0;
    }
    .triangle-right.motorbtn{
        border-left: 40px solid #dd102c;
    }
    .borderWhite {
        margin-bottom: 25px;
    }
    .ImageLogoSection {
        padding: 0;
    }
    .aboutBlocks {
        padding: 30px;
        height: 645px;
    }
    .AboutTrackMan {
        padding: 25px;
        padding-top: 50px;
    }
    .container {
        padding-left: 0;
        padding-right: 0;
    }
    .aboutTrack-width {
        width: 100%;
        text-align: center;
        margin: auto;
        padding-top: 30px;
        padding-bottom: 30px;
    }
    .optionAbout {
        margin: auto;
        margin-right: 0px
    }
    .Whitetitle {
        font-size: 36px;
        margin-top: 30px;
    }
    .WhiteStandard-text{
        font-size: 20px;
    }
}
@media only screen and (max-width: 375px) {
    .aboutBlocks {
        padding: 30px;
        height: 645px;
    }
}
</style>
